// Чаты покупателя: общий кэш списка тредов для страницы /chats и счётчика
// непрочитанных в шапке. Список опрашивается, пока вкладка видима.
import { useQuery } from "@tanstack/react-query";

import { useProfile } from "@/store/profile";

import { api } from "./client";

export const chatKeys = {
	list: (userId: string) => ["buyer", userId, "conversations"] as const,
	detail: (userId: string, id: string) => ["buyer", userId, "conversation", id] as const,
};

const visible = () => typeof document === "undefined" || document.visibilityState === "visible";

export function useBuyerConversations(pollMs = 5000) {
	const token = useProfile((s) => s.token);
	const userId = useProfile((s) => s.user?.id);
	const hydrating = useProfile((s) => s.isHydrating);
	return useQuery({
		queryKey: chatKeys.list(userId ?? "guest"),
		queryFn: () => api.buyer.listConversations(),
		enabled: Boolean(token && userId && !hydrating),
		staleTime: 2000,
		refetchInterval: () => (visible() ? pollMs : false),
	});
}

export function useBuyerConversation(id: string | null) {
	const userId = useProfile((s) => s.user?.id);
	return useQuery({
		queryKey: chatKeys.detail(userId ?? "guest", id ?? "none"),
		queryFn: () => api.buyer.getConversation(id ?? ""),
		enabled: Boolean(userId && id),
		staleTime: 1000,
		retry: false,
		refetchInterval: () => (visible() ? 3000 : false),
	});
}

// Сумма непрочитанных по всем тредам — бейдж иконки чата в шапке.
export function useChatUnreadTotal(): number {
	const list = useBuyerConversations(15000);
	return (list.data ?? []).reduce((sum, c) => sum + (c.unreadCount ?? 0), 0);
}
